export const INITIAL_DUE_DILIGENCE = Object.freeze({
  PORTFOLIO_NAME: { id: 1, fieldName: 'portfolioName' },
  COMPANY: { id: 2, fieldName: 'companyId' },
  FACILITY_NAME: { id: 3, fieldName: 'facilityName' },
  FACILITY_SHORT_NAME: { id: 4, fieldName: 'shortName' },
  FACILITY_DBA: { id: 5, fieldName: 'facilityDBA' },
  FACILITY_STRUCTURE: { id: 6, fieldName: 'facilityStructureId' },
  FACILITY_EIN: { id: 7, fieldName: 'facilityEIN' },
  AVERAGE_CENSUS: { id: 8, fieldName: 'averageCensus' },
  BED_COUNT_SNF: { id: 9, fieldName: 'bedCount' },
  BED_COUNT_ILF: { id: 415, fieldName: 'bedCountILF' },
  BED_COUNT_ALF: { id: 416, fieldName: 'bedCountALF' },
  BED_COUNT_PC: { id: 417, fieldName: 'bedCountPC' },
  FACILITY_ADDRESS: { id: 10, fieldName: 'address' },
  FACILITY_CITY: { id: 418, fieldName: 'city' },
  FACILITY_COUNTY: { id: 419, fieldName: 'county' },
  FACILITY_STATE: { id: 420, fieldName: 'state' },
  FACILITY_ZIP: { id: 421, fieldName: 'zip' },
  BANK_NAME: { id: 11, fieldName: 'bankName' },
  BANK_PHONE_NUMBER: { id: 12, fieldName: 'bankPhoneNumber' },
  ROUTING_NUMBER: { id: 13, fieldName: 'routingNumber' },
  BANK_ADDRESS: { id: 15, fieldName: 'bankAddress' },
  BANK_REPRESENTATIVE: { id: 16, fieldName: 'bankRep' },
  BANK_REPRESENTATIVE_PHONE_NUMBER: { id: 17, fieldName: 'bankRepPhoneNumber' },
  BANK_REPRESENTATIVE_EMAIL: { id: 18, fieldName: 'bankRepEmail' },
  AP_PHONE_NUMBER: { id: 19, fieldName: 'apPhoneNumber' },
  AP_NAME: { id: 20, fieldName: 'apName' },
  AP_EMAIL: { id: 21, fieldName: 'apEmail' },
});

export const DIETARY = Object.freeze({
  DIETARY_STAFFING_SCHEDULE: { id: 126, fieldName: 'dietaryStaffingSchedule' },
  FOOD_COMMITTEE_MEETINGS: { id: 127, fieldName: 'foodCommitteeMeetings' },
  COPY_OF_MENUS: { id: 128, fieldName: 'copyOfMenus' },
  ALTERED_CONSISTENCY_DIETS: { id: 129, fieldName: 'alteredConsistencyDiets' },
  THERAPEUTIC_RESTRICTIONS: { id: 130, fieldName: 'therapeuticRestrictions' },
  DIETARY_SUPPLEMENTS: { id: 131, fieldName: 'dietarySupplements' },
  DIETARY_DIRECTOR: { id: 132, fieldName: 'dietaryDirector' },
  DIETARY_IS_OUTSOURCED: { id: 133, fieldName: 'isOutsourced' },
  DIETARY_DEPARTMENT_OUTSOURCED_CATEGORY: { id: 134, fieldName: 'outsourcedCategoryId' },
  DIETARY_DEPARTMENT_OUTSOURCED_VENDOR: { id: 135, fieldName: 'dietaryOutsourcedVendor' },
  DIETARY_DEPARTMENT_OUTSOURCED_PHONE: { id: 136, fieldName: 'outsourcedPhone' },
  DIETARY_DEPARTMENT_OUTSOURCED_EMAIL: { id: 137, fieldName: 'outsourcedEmail' },
  DIETARY_DEPARTMENT_OUTSOURCED_HOURS_PER_WEEK: { id: 138, fieldName: 'outsourcedHoursPerWeek' },
  MAIN_FOOD_SUPPLIER: { id: 147, fieldName: 'mainFoodSupplier' },
  SECONDARY_FOOD_SUPPLIER: { id: 148, fieldName: 'secondaryFoodSupplier' },
  DAIRY_PROVIDER: { id: 149, fieldName: 'dairyProvider' },
  BAKERY_PROVIDER: { id: 150, fieldName: 'bakeryProvider' },
  CHEMICAL_PROVIDER: { id: 151, fieldName: 'chemicalProvider' },
  PAPER_PLASTIC_VENDOR: { id: 152, fieldName: 'paperPlasticVendor' },
  COFFEE_VENDOR: { id: 153, fieldName: 'coffeeVendor' },
  DISH_MACHINE_OWNERSHIP_TYPE: { id: 193, fieldName: 'dishMachineOwnershipType' },
  DISH_MACHINE_SERIAL: { id: 194, fieldName: 'dishMachineSerial' },
  DISH_MACHINE_MANUFACTURER: { id: 195, fieldName: 'dishMachineManufacturer' },
  DISH_MACHINE_MODEL_NUMBER: { id: 196, fieldName: 'dishMachineModelNumber' },
  DISH_MACHINE_PURCHASED_DATE: { id: 197, fieldName: 'dishMachinePurchasedDate' },
  DISH_MACHINE_IS_FINANCED: { id: 198, fieldName: 'dishMachineIsFinanced' },
  DISH_MACHINE_FINANCE_AGREEMENT: { id: 199, fieldName: 'dishMachineFinanceAgreement' },
  DISH_MACHINE_LEASED_COMPANY_NAME: { id: 200, fieldName: 'dishMachineLeasedCompanyName' },
  DISH_MACHINE_LEASED_PHONE_NUMBER: { id: 201, fieldName: 'dishMachineLeasedPhoneNumber' },
  DISH_MACHINE_LEASED_EMAIL: { id: 202, fieldName: 'dishMachineLeasedEmail' },
  DISH_MACHINE_LEASED_COMPANY_ADDRESS: { id: 203, fieldName: 'dishMachineLeasedCompanyAddress' },
  DISH_MACHINE_LEASED_AGREEMENT: { id: 204, fieldName: 'dishMachineLeasedAgreement' },
  DISH_MACHINE_RENTAL_COMPANY_NAME: { id: 205, fieldName: 'dishMachineRentalCompanyName' },
  DISH_MACHINE_RENTAL_PHONE_NUMBER: { id: 206, fieldName: 'dishMachineRentalPhoneNumber' },
  DISH_MACHINE_RENTAL_EMAIL: { id: 207, fieldName: 'dishMachineRentalEmail' },
  DISH_MACHINE_RENTAL_COMPANY_ADDRESS: { id: 208, fieldName: 'dishMachineRentalCompanyAddress' },
  DISH_MACHINE_RENTAL_CONTRACT: { id: 209, fieldName: 'dishMachineRentalContract' },
  CURRENT_MENU_SYSTEM: { id: 422, fieldName: 'currentMenuSystem' },
  CURRENT_MENU_SYSTEM_CONTRACT: { id: 423, fieldName: 'currentMenuSystemContract' },
  DIETICIAN: { id: 424, fieldName: 'dietician' },
  OUTSOURCED_DIETICIAN: { id: 425, fieldName: 'outsourcedDietician' },
  OUTSOURCED_DIETICIAN_CONTACT: { id: 426, fieldName: 'outsourcedDieticianContact' },
  OUTSOURCED_DIETICIAN_HOURS_PER_WEEK: { id: 427, fieldName: 'outsourcedDieticianHoursPerWeek' },
  OUTSOURCED_DIETICIAN_CONTRACTED_RATE: { id: 428, fieldName: 'outsourcedDieticianContractedRate' },
  OUTSOURCED_DIETICIAN_CONTRACTED_PRICE: { id: 429, fieldName: 'outsourcedDieticianContractedPrice' },
});

export const OPERATIONS = Object.freeze({
  LAST_3_ANNUAL_SURVEYS: { id: 140, fieldName: 'last3AnnualSurveys' },
  LAST_3_YEARS_COMPLAINTS: { id: 141, fieldName: 'last3YearsComplaints' },
  CORPORATE_COMPLIANCE: { id: 142, fieldName: 'corporateCompliance' },
  NURSING_STAFFING_SCHEDULE: { id: 143, fieldName: 'nursingStaffingSchedule' },
  DIETARY_STAFFING_SCHEDULE: { id: 144, fieldName: 'dietaryStaffingSchedule' },
  HOUSEKEEPING_STAFFING_SCHEDULE: { id: 145, fieldName: 'housekeepingStaffingSchedule' },
  LAUNDRY_STAFFING_SCHEDULE: { id: 146, fieldName: 'laundryStaffingSchedule' },
  ADMINISTRATOR: { id: 154, fieldName: 'administrator' },
  ASSISTANT_ADMINISTRATOR: { id: 155, fieldName: 'assistantAdministrator' },
  DIRECTOR_OF_NURSING: { id: 156, fieldName: 'directorOfNursing' },
  ADON: { id: 157, fieldName: 'adon' },
  MDSRNACLNAC_DIRECTOR: { id: 158, fieldName: 'mdsrnaclnacDirector' },
  MAINTENANCE_DIRECTOR: { id: 159, fieldName: 'maintenanceDirector' },
  HOUSEKEEPING_DIRECTOR: { id: 160, fieldName: 'housekeepingDirector' },
  DIETARY_DIRECTOR: { id: 161, fieldName: 'dietaryDirector' },
  DIETICIAN: { id: 162, fieldName: 'dietician' },
  CENTRAL_SUPPLIES_DIRECTOR: { id: 163, fieldName: 'centralSuppliesDirector' },
  INFECTION_CONTROL: { id: 164, fieldName: 'infectionControl' },
  SCHEDULER: { id: 165, fieldName: 'scheduler' },
  ACTIVITIES_DIRECTOR: { id: 166, fieldName: 'activitiesDirector' },
  BUSINESS_OFFICE_MANAGER: { id: 167, fieldName: 'businessOfficeManager' },
  HR_DIRECTOR: { id: 168, fieldName: 'hrDirector' },
  SOCIAL_SERVICES_DIRECTOR: { id: 169, fieldName: 'socialServicesDirector' },
  MEDICAL_RECORDS_DIRECTOR: { id: 170, fieldName: 'medicalRecordsDirector' },
  UNIT_MANAGER: { id: 171, fieldName: 'unitManager' },
  MARKETER: { id: 172, fieldName: 'marketer' },
  CLINICAL_LIAISON: { id: 173, fieldName: 'clinicalLiaison' },
  ADMISSIONS_DIRECTOR: { id: 174, fieldName: 'admissionsDirector' },
  EMAIL_DOMAIN: { id: 175, fieldName: 'emailDomain' },
  CORPORATE_COMPLIANCE_IS_CONTRACTED: { id: 176, fieldName: 'corporateComplianceIsContracted' },
  CORPORATE_COMPLIANCE_VENDOR: { id: 177, fieldName: 'corporateComplianceVendor' },
  CORPORATE_COMPLIANCE_MONTHLY_CHARGE: { id: 178, fieldName: 'corporateComplianceMonthlyCharge' },
  MD_FIRST_NAME: { id: 180, fieldName: 'mdFirstName' },
  MD_LAST_NAME: { id: 181, fieldName: 'mdLastName' },
  MD_ADDRESS: { id: 182, fieldName: 'mdAddress' },
  MD_CITY: { id: 183, fieldName: 'mdCity' },
  MD_STATE: { id: 184, fieldName: 'mdState' },
  MD_ZIP: { id: 185, fieldName: 'mdZip' },
  MD_PHONE_NUMBER: { id: 186, fieldName: 'mdPhoneNumber' },
  MD_FAX: { id: 187, fieldName: 'mdFax' },
  MD_EMAIL: { id: 188, fieldName: 'mdEmail' },
  MD_COMPANY: { id: 243, fieldName: 'mdCompany' },
  NPI_NUMBER: { id: 189, fieldName: 'npiNumber' },
  DEA_NUMBER: { id: 190, fieldName: 'deaNumber' },
  MEDICAL_DIRECTOR_LICENSE: { id: 191, fieldName: 'medicalDirectorLicense' },
  MEDICAL_DIRECTOR_CONTRACT: { id: 192, fieldName: 'medicalDirectorContract' },
});

export const REPORTS = Object.freeze({
  CHECKLIST: { id: 210, fieldName: 'checklist' },
  EMAR_DATA_SOURCE: { id: 211, fieldName: 'emarDataSource' },
  EMAR_EMAIL: { id: 212, fieldName: 'emarEmail' },
  TIMECLOCK_LABOR_DATA_SOURCE: { id: 213, fieldName: 'timeclockLaborDataSource' },
  TIMECLOCK_LABOR_DATA_EMAIL: { id: 214, fieldName: 'timeclockLaborDataEmail' },
  TIMECLOCK_LABOR_DATA_INTEGRATION_TYPE: { id: 215, fieldName: 'timeclockLaborDataIntegrationType' },
});

export const CLINICAL_REIMBURSEMENT = Object.freeze({
  MEDICARE_CENSUS_COUNT: { id: 216, fieldName: 'medicareCensusCount' },
  MEDICAID_CENSUS_COUNT: { id: 217, fieldName: 'medicaidCensusCount' },
  MANAGED_CARE_CENSUS_COUNT: { id: 218, fieldName: 'managedCareCensusCount' },
  PRIVATE_PAY_CENSUS_COUNT: { id: 219, fieldName: 'privatePayCensusCount' },
  BUDGETED_MDS_HOURS: { id: 220, fieldName: 'budgetedMDSHours' },
  OPEN_POSITIONS: { id: 221, fieldName: 'openPositions' },
  BENEFICIARY_NOTICE_PROCESS: { id: 222, fieldName: 'beneficiaryNoticeProcess' },
  CARE_PLAN_PROCESS: { id: 223, fieldName: 'carePlanProcess' },
  WEEKLY_UTILIZATION_REVIEW_PROCESS: { id: 224, fieldName: 'weeklyUtilizationReviewProcess' },
  DISCHARGE_PLANNING_PROCESS: { id: 225, fieldName: 'dischargePlanningProcess' },
  SELLER_MEDICARE_NUMBER: { id: 226, fieldName: 'sellerMedicareNumber' },
  MEDICARE_A_CERTIFICATION_FILE: { id: 227, fieldName: 'medicareACertificationFile' },
  MDS_SCRUBBER: { id: 228, fieldName: 'mdsScrubber' },
  MDS_SUBMISSION_PROCESS: { id: 229, fieldName: 'mdsSubmissionProcess' },
  ICD10_PROCESS: { id: 230, fieldName: 'icd10Process' },
  CASE_MANAGEMENT_PROCESS: { id: 231, fieldName: 'caseManagementProcess' },
  TRIPLE_CHECK_PROCESS: { id: 232, fieldName: 'tripleCheckProcess' },
  REHAB_OUTSOURCED_COMPANY_CATEGORY_ID: { id: 233, fieldName: 'rehabOutsourcedCompanyCategoryId' },
  EMR_SOFTWARE_VENDOR: { id: 234, fieldName: 'emrSoftwareVendor' },
  REHAB_VENDOR: { id: 235, fieldName: 'rehabVendor' },
});

export const BUSINESS_DEVELOPMENT = Object.freeze({
  BED_COUNT: { id: 244, fieldName: 'bedCount' },
  TWELVE_MONTH_LOOK_BACK_FILE: { id: 245, fieldName: 'twelveMonthLookBackFile' },
  W9_FILE: { id: 246, fieldName: 'w9File' },
  EIN_NUMBER: { id: 247, fieldName: 'EINNumber' },
  NPI_NUMBER: { id: 248, fieldName: 'NPINumber' },
  REFERRING_HOSPITALS: { id: 249, fieldName: 'referringHospitals' },
  MANAGED_CARE_VA_INSURANCE_CONTRACTS: { id: 250, fieldName: 'managedCareVAInsuranceContracts' },
  MEDICAL_DIRECTOR_FIRST_NAME: { id: 251, fieldName: 'medicalDirectorFirstName' },
  MEDICAL_DIRECTOR_CONTRACT: { id: 252, fieldName: 'medicalDirectorContract' },
  ADMISSIONS_DIRECTOR: { id: 253, fieldName: 'admissionsDirector' },
  HOME_HEALTH_AGENCIES: { id: 254, fieldName: 'homeHealthAgencies' },
  HOSPICE_AGENCIES: { id: 255, fieldName: 'hospiceAgencies' },
  FACILITY_PROGRAMS: { id: 288, fieldName: 'facilityPrograms' },
  MARKETER: { id: 289, fieldName: 'marketer' },
  CLINICAL_LIAISON: { id: 290, fieldName: 'clinicalLiaison' },
  WEBSITE_DOMAIN: { id: 291, fieldName: 'websiteDomain' },
  WEBSITE_DOMAIN_ACCESS: { id: 292, fieldName: 'websiteDomainAccess' },
  GOOGLE_BUSINESS_ACCESS: { id: 293, fieldName: 'googleBusinessAccess' },
  SOCIAL_MEDIA_OPTIONS: { id: 294, fieldName: 'socialMediaOptions' },
  SOCIAL_MEDIA_ACCESS: { id: 295, fieldName: 'socialMediaAccess' },
  REFERRAL_SOFTWARES: { id: 296, fieldName: 'referralSoftwares' },
});

export const TELECOMMUNICATIONS = Object.freeze({
  PHONE_SERVICE_PROVIDER: { id: 260, fieldName: 'phoneServiceProvider' },
  PHONE_MONTHLY_COST: { id: 261, fieldName: 'phoneMonthlyCost' },
  IS_PHONE_EQUIPMENT_LEASED: { id: 262, fieldName: 'isPhoneEquipmentLeased' },
  PHONE_LEASE_MONTHLY_COST: { id: 263, fieldName: 'phoneLeaseMonthlyCost' },
  PHONE_MAKE: { id: 264, fieldName: 'phoneMake' },
  PHONE_MODEL: { id: 265, fieldName: 'phoneModel' },
  EQUIPMENT_SERVICE_PROVIDER: { id: 266, fieldName: 'equipmentServiceProvider' },
  INTERNET_PROVIDER: { id: 267, fieldName: 'internetProvider' },
  INTERNET_MONTHLY_COST: { id: 268, fieldName: 'internetMonthlyCost' },
  IS_INTERNET_EQUIPMENT_LEASED: { id: 269, fieldName: 'isInternetEquipmentLeased' },
  INTERNET_LEASE_MONTHLY_COST: { id: 270, fieldName: 'internetLeaseMonthlyCost' },
  INTERNET_CIRCUIT_TYPE: { id: 271, fieldName: 'internetCircuitType' },
  INTERNET_BANDWIDTH: { id: 272, fieldName: 'internetBandwidth' },
  INTERNET_BACKUP_CIRCUIT_TYPE: { id: 273, fieldName: 'internetBackupCircuitType' },
  INTERNET_BACKUP_BANDWIDTH: { id: 274, fieldName: 'internetBackupBandwidth' },
  TV_PROVIDER: { id: 275, fieldName: 'tvProvider' },
  TV_MONTHLY_COST: { id: 276, fieldName: 'tvMonthlyCost' },
  IS_TV_EQUIPMENT_LEASED: { id: 277, fieldName: 'isTVEquipmentLeased' },
  TV_LEASE_MONTHLY_COST: { id: 278, fieldName: 'tvLeaseMonthlyCost' },
  CHANNEL_LINEUP: { id: 279, fieldName: 'channelLineup' },
  NUMBER_OF_TV_OUTLETS: { id: 280, fieldName: 'numberOfTVOutlets' },
  NUMBER_OF_TV_CHANNELS: { id: 281, fieldName: 'numberOfTVChannels' },
  IT_PROVIDER: { id: 282, fieldName: 'itProvider' },
  IT_MONTHLY_COST: { id: 283, fieldName: 'itMonthlyCost' },
});

export const VENDORS = Object.freeze({
  STAFFING_AGENCY_VENDOR: { id: 297, fieldName: 'staffingAgencyVendor' },
  EMR_SOFTWARE_VENDOR: { id: 298, fieldName: 'emrSoftwareVendor' },
  DME_SUPPLY_VENDOR: { id: 299, fieldName: 'dmeSupplyVendor' },
  MEDICAL_DIRECTOR_VENDOR: { id: 300, fieldName: 'medicalDirectorVendor' },
  MEDICAL_SUPPLIES_VENDOR: { id: 301, fieldName: 'medicalSuppliesVendor' },
  PHARMACY_VENDOR: { id: 302, fieldName: 'pharmacyVendor' },
  PHARMACY_CONSULTANT_VENDOR: { id: 303, fieldName: 'pharmacyConsultantVendor' },
  LAB_COVID_TEST_VENDOR: { id: 304, fieldName: 'labCovidTestVendor' },
  LABS_VENDOR: { id: 305, fieldName: 'labsVendor' },
  X_RAY_VENDOR: { id: 306, fieldName: 'xRayVendor' },
  DME_RENTAL_VENDOR: { id: 307, fieldName: 'dmeRentalVendor' },
  WHEELCHAIR_TRANSPORT_VENDOR: { id: 308, fieldName: 'wheelchairTransportVendor' },
  STRETCHER_TRANSPORT_VENDOR: { id: 309, fieldName: 'stretcherTransportVendor' },
  MEDICAL_WASTE_VENDOR: { id: 310, fieldName: 'medicalWasteVendor' },
  OXYGEN_PROVIDER: { id: 311, fieldName: 'oxygenProvider' },
  OXYGEN_RENTAL_PROVIDER: { id: 312, fieldName: 'oxygenRentalProvider' },
  ENTERALS_OUTS_PART_B_SUPPLY_BILLING_VENDOR: { id: 313, fieldName: 'enteralsOUTsPartBSupplyBillingVendor' },
  WOUND_CARE_PART_B_SUPPLY_BILLING_VENDOR: { id: 314, fieldName: 'woundCarePartBSupplyBillingVendor' },
  WOUND_PHYSICIAN_NURSE_VENDOR: { id: 315, fieldName: 'woundPhysicianNurseVendor' },
  PICC_MIDLINE_INSERTION_VENDOR: { id: 316, fieldName: 'piccMidlineInsertionVendor' },
  REHAB_VENDOR: { id: 317, fieldName: 'rehabVendor' },
  EQUIPMENT_LEASE_VENDOR: { id: 318, fieldName: 'equipmentLeaseVendor' },
  EQUIPMENT_RENTALS_VENDOR: { id: 319, fieldName: 'equipmentRentalsVendor' },
  THERAPY_OUTSOURCED_COMPANY: { id: 320, fieldName: 'therapyOutsourcedCompany' },
  THERAPY_STAFFING_AGENCY: { id: 321, fieldName: 'therapyStaffingAgency' },
  THERAPY_SUPPLIES_PROVIDER: { id: 322, fieldName: 'therapySuppliesProvider' },
  THERAPY_SOFTWARE_VENDOR: { id: 323, fieldName: 'therapySoftwareVendor' },
  THERAPY_MANAGEMENT_COMPANY: { id: 324, fieldName: 'therapyManagementCompany' },
  DIETARY_OUTSOURCED_COMPANY: { id: 325, fieldName: 'dietaryOutsourcedCompany' },
  MAIN_FOOD_VENDOR: { id: 326, fieldName: 'mainFoodVendor' },
  SECONDARY_FOOD_VENDOR: { id: 327, fieldName: 'secondaryFoodVendor' },
  DAIRY_VENDOR: { id: 328, fieldName: 'dairyVendor' },
  BREAD_VENDOR: { id: 329, fieldName: 'breadVendor' },
  COFFEE_VENDOR: { id: 330, fieldName: 'coffeeVendor' },
  JUICE_VENDOR: { id: 331, fieldName: 'juiceVendor' },
  DIETARY_STAFFING_VENDOR: { id: 332, fieldName: 'dietaryStaffingVendor' },
  OUTSOURCED_DIETICIAN_VENDOR: { id: 333, fieldName: 'outsourcedDieticianVendor' },
  DIETARY_EQUIPMENT_RENTAL_VENDOR: { id: 334, fieldName: 'dietaryEquipmentRentalVendor' },
  DIETARY_SUPPLIES_VENDOR: { id: 335, fieldName: 'dietarySuppliesVendor' },
  MENU_TICKET_SYSTEM_VENDOR: { id: 336, fieldName: 'menuTicketSystemVendor' },
  DIETARY_CHEMICALS_VENDOR: { id: 337, fieldName: 'dietaryChemicalsVendor' },
  BAKERY_VENDOR: { id: 338, fieldName: 'bakeryVendor' },
  HOUSEKEEPING_SUPPLIES_VENDOR: { id: 339, fieldName: 'housekeepingSuppliesVendor' },
  HOUSEKEEPING_CHEMICALS_VENDOR: { id: 340, fieldName: 'housekeepingChemicalsVendor' },
  HOUSEKEEPING_AND_LAUNDRY_OUTSOURCED_COMPANY: { id: 341, fieldName: 'housekeepingAndLaundryOutsourcedCompany' },
  LINEN_SUPPLIER_VENDOR: { id: 342, fieldName: 'linenSupplierVendor' },
  HOUSEKEEPING_EQUIPMENT_RENTAL_VENDOR: { id: 343, fieldName: 'housekeepingEquipmentRentalVendor' },
  MAINTENANCE_SOFTWARE_VENDOR: { id: 344, fieldName: 'maintenanceSoftwareVendor' },
  MAINTENANCE_SERVICE_PROVIDER: { id: 345, fieldName: 'maintenanceServiceProvider' },
  ELEVATOR_SERVICE_COMPANY: { id: 346, fieldName: 'elevatorServiceCompany' },
  MAINTENANCE_SUPPLIES_VENDOR: { id: 347, fieldName: 'maintenanceSuppliesVendor' },
  FIRE_SAFETY_VENDOR: { id: 348, fieldName: 'fireSafetyVendor' },
  SECURITY_SYSTEM_VENDOR: { id: 349, fieldName: 'securitySystemVendor' },
  TV_AND_CABLE_VENDOR: { id: 350, fieldName: 'tvAndCableVendor' },
  ELECTRIC_UTILITY_VENDOR: { id: 351, fieldName: 'electricUtilityVendor' },
  GAS_UTILITY_VENDOR: { id: 352, fieldName: 'gasUtilityVendor' },
  WATER_AND_SEWER_UTILITY_VENDOR: { id: 353, fieldName: 'waterAndSewerUtilityVendor' },
  WASTE_HAULING_VENDOR: { id: 354, fieldName: 'wasteHaulingVendor' },
  MAINTENANCE_EQUIPMENT_RENTAL_VENDOR: { id: 355, fieldName: 'maintenanceEquipmentRentalVendor' },
  PEST_CONTROL_VENDOR: { id: 356, fieldName: 'pestControlVendor' },
  GENERATOR_SERVICE_COMPANY: { id: 357, fieldName: 'generatorServiceCompany' },
  LANDSCAPING_VENDOR: { id: 358, fieldName: 'landscapingVendor' },
  HOOD_VENT_CLEANING_VENDOR: { id: 359, fieldName: 'hoodVentCleaningVendor' },
  GREASE_TRAP_CLEANING_PROVIDER: { id: 360, fieldName: 'greaseTrapCleaningProvider' },
  WATER_SOFTENING_VENDOR: { id: 361, fieldName: 'waterSofteningVendor' },
  IT_VENDOR: { id: 362, fieldName: 'itVendor' },
  COPIER_MACHINE_SERVICE_COMPANY: { id: 363, fieldName: 'copierMachineServiceCompany' },
  COPIER_MACHINE_LEASE_COMPANY: { id: 364, fieldName: 'copierMachineLeaseCompany' },
  MEDICAL_FORMS_VENDOR: { id: 365, fieldName: 'medicalFormsVendor' },
  INTERNET_SERVICE_PROVIDER: { id: 366, fieldName: 'internetServiceProvider' },
  BACKUP_INTERNET_PROVIDER: { id: 367, fieldName: 'backupInternetProvider' },
  PHONE_PROVIDER: { id: 368, fieldName: 'phoneProvider' },
  PHONE_SERVICE_COMPANY: { id: 369, fieldName: 'phoneServiceCompany' },
  SHREDDING_COMPANY: { id: 370, fieldName: 'shreddingCompany' },
  DOCU_STORAGE_COMPANY: { id: 371, fieldName: 'docuStorageCompany' },
  E_FAX_VENDOR: { id: 372, fieldName: 'eFaxVendor' },
  BACKGROUND_CHECKS_VENDOR: { id: 373, fieldName: 'backgroundChecksVendor' },
  OFFICE_SUPPLIES_VENDOR: { id: 374, fieldName: 'officeSuppliesVendor' },
  MARKETING_SUPPLIES_VENDOR: { id: 375, fieldName: 'marketingSuppliesVendor' },
  CORPORATE_COMPLIANCE_VENDOR: { id: 376, fieldName: 'corporateComplianceVendor' },
  PURCHASING_SOFTWARE_VENDOR: { id: 377, fieldName: 'purchasingSoftwareVendor' },
  ACCOUNTANT_VENDOR: { id: 378, fieldName: 'accountantVendor' },
  AP_SOFTWARE_VENDOR: { id: 379, fieldName: 'apSoftwareVendor' },
  RFMS_SOFTWARE_VENDOR: { id: 380, fieldName: 'rfmsSoftwareVendor' },
  MAIL_AND_POSTAGE_VENDOR: { id: 381, fieldName: 'mailAndPostageVendor' },
  HMO_CONTRACT_NEGOTIATION_PROVIDER: { id: 382, fieldName: 'hmoContractNegotiationProvider' },
  UNEMPLOYMENT_LAWYER_VENDOR: { id: 383, fieldName: 'unemploymentLawyerVendor' },
  TIME_AND_ATTENDANCE_SOFTWARE_VENDOR: { id: 384, fieldName: 'timeAndAttendanceSoftwareVendor' },
  WOUND_VAC_VENDOR: { id: 385, fieldName: 'woundVacVendor' },
  AUDIT_VENDOR: { id: 386, fieldName: 'auditVendor' },
  ACTIVITY_SUPPLIES_VENDOR: { id: 387, fieldName: 'activitySuppliesVendor' },
  MDS_SCRUBBER_VENDOR: { id: 388, fieldName: 'mdsScrubberVendor' },
  INSURANCE_VERIFICATION_SOFTWARE_VENDOR: { id: 389, fieldName: 'insuranceVerificationSoftwareVendor' },
  PAYROLL_VENDOR: { id: 390, fieldName: 'payrollVendor' },
  VISITOR_SCREENING_VENDOR: { id: 391, fieldName: 'visitorScreeningVendor' },
  POLICY_AND_PROCEDURE_VENDOR: { id: 392, fieldName: 'policyAndProcedureVendor' },
  PHONE_ON_HOLD_VENDOR: { id: 393, fieldName: 'phoneOnHoldVendor' },
  VENDING_MACHINE_SERVICES_VENDOR: { id: 394, fieldName: 'vendingMachineServicesVendor' },
  FACILITY_VAN_VENDOR: { id: 395, fieldName: 'facilityVanVendor' },
  PROMO_ITEMS_VENDOR: { id: 396, fieldName: 'promoItemsVendor' },
  MEDICAL_EQUIPMENT_PM_SERVICES_VENDOR: { id: 397, fieldName: 'medicalEquipmentPMServicesVendor' },
  RECRUITMENT_ONBOARDING_VENDOR: { id: 398, fieldName: 'recruitmentOnboardingVendor' },
  EMPLOYEE_SCHEDULING_SOFTWARE_VENDOR: { id: 399, fieldName: 'employeeSchedulingSoftwareVendor' },
  REFERRAL_SOFTWARE_VENDOR: { id: 400, fieldName: 'referralSoftwareVendor' },
  PHONE_EQUIPMENT_SERVICE_PROVIDER: { id: 401, fieldName: 'phoneEquipmentServiceProvider' },
  PAPER_PLASTIC_VENDOR: { id: 402, fieldName: 'paperPlasticVendor' },
  TRANSPORTATION_VENDOR: { id: 403, fieldName: 'transportationVendor' },
  EMERGENCY_ICE_VENDOR: { id: 404, fieldName: 'emergencyIceVendor' },
  EMERGENCY_WATER_VENDOR: { id: 405, fieldName: 'emergencyWaterVendor' },
  PETROLEUM_PROVIDER: { id: 406, fieldName: 'petroleumProvider' },
  RECIPROCAL_TRANSFER_AGREEMENT_VENDOR: { id: 407, fieldName: 'reciprocalTransferAgreementVendor' },
  REFRIGERATED_TRUCK_VENDOR: { id: 408, fieldName: 'refrigeratedTruckVendor' },
  HOSPICE_VENDOR: { id: 409, fieldName: 'hospiceVendor' },
  PODIATRY_VENDOR: { id: 410, fieldName: 'podiatryVendor' },
  DENTAL_VENDOR: { id: 411, fieldName: 'dentalVendor' },
  BEAUTY_AND_BARBER_VENDOR: { id: 412, fieldName: 'beautyAndBarberVendor' },
  EYE_DOCTOR_VENDOR: { id: 413, fieldName: 'eyeDoctorVendor' },
  EDUCATION_VENDOR: { id: 414, fieldName: 'educationVendor' },
});

export const PLANT_OPERATIONS = Object.freeze({
  PHASE_ONE_REPORTS: { id: 431, fieldName: 'phaseOneReports' },
  PHASE_TWO_REPORTS: { id: 432, fieldName: 'phaseTwoReports' },
  FACILITY_FLOOR_PLAN: { id: 433, fieldName: 'facilityFloorPlan' },
  WARRANTIED_EQUIPMENT: { id: 434, fieldName: 'warrantiedEquipment' },
  HAS_VALVE_DIAGRAM: { id: 435, fieldName: 'hasValveDiagram' },
});

export const PAYROLL = Object.freeze({
  PAYROLL_VENDOR: { id: 436, fieldName: 'payrollVendor' },
  NUMBER_OF_TIME_CLOCKS: { id: 437, fieldName: 'numberOfTimeClocks' },
  EMPLOYEE_PAYROLL_FORM: { id: 438, fieldName: 'employeePayrollForm' },
  TIME_AND_ATTENDANCE_SOFTWARE_VENDOR: { id: 439, fieldName: 'timeAndAttendanceSoftwareVendor' },
  CURRENT_EMPLOYEES_HANDBOOK: { id: 440, fieldName: 'currentEmployeesHandbook' },
  COLLECTIVE_BARGAINING_CONTRACTS: { id: 441, fieldName: 'collectiveBargainingContracts' },
  TIME_CARD_REPORT: { id: 442, fieldName: 'timeCardReport' },
  PAYROLL_REPORT: { id: 443, fieldName: 'payrollReport' },
  HOLIDAY_PAY_RULE: { id: 444, fieldName: 'holidayPayRule' },
  SECOND_SHIFT_PAY_RULE: { id: 445, fieldName: 'secondShiftPayRule' },
  THIRD_SHIFT_PAY_RULE: { id: 446, fieldName: 'thirdShiftPayRule' },
  WEEKEND_SHIFT_PAY_RULE: { id: 447, fieldName: 'weekendShiftPayRule' },
  OVERTIME_PAY_RULE: { id: 448, fieldName: 'overtimePayRule' },
  PTO_PAY_RULE: { id: 449, fieldName: 'ptoPayRule' },
  FINAL_BALANCE: { id: 450, fieldName: 'finalBalance' },
  HOUSEKEEPING_IS_OUTSOURCED: { id: 451, fieldName: 'housekeepingIsOutsourced' },
  HOUSEKEEPING_OUTSOURCED_CATEGORY_ID: { id: 452, fieldName: 'housekeepingOutsourcedCategoryId' },
  HOUSEKEEPING_OUTSOURCED_HOURS_PER_WEEK: {
    id: 453,
    fieldName: 'housekeepingOutsourcedHoursPerWeek',
  },
  HOUSEKEEPING_AVERAGE_MONTHLY_COST: { id: 454, fieldName: 'housekeepingAverageMonthlyCost' },
  HOUSEKEEPING_AND_LAUNDRY_OUTSOURCE_VENDOR: { id: 455, fieldName: 'housekeepingAndLaundryOutsourceVendor' },
  DIETARY_IS_OUTSOURCED: { id: 456, fieldName: 'dietaryIsOutsourced' },
  DIETARY_OUTSOURCED_CATEGORY_ID: { id: 457, fieldName: 'dietaryOutsourcedCategoryId' },
  OUTSOURCED_DIETARY_VENDOR: { id: 458, fieldName: 'outsourcedDietaryVendor' },
  DIETARY_OUTSOURCED_PHONE: { id: 459, fieldName: 'dietaryOutsourcedPhone' },
  DIETARY_OUTSOURCED_EMAIL: { id: 460, fieldName: 'dietaryOutsourcedEmail' },
  DIETARY_OUTSOURCED_HOURS_PER_WEEK: { id: 461, fieldName: 'dietaryOutsourcedHoursPerWeek' },
  THERAPY_OUTSOURCED_CATEGORY_ID: { id: 463, fieldName: 'therapyOutsourcedCategoryId' },
  THERAPY_VENDOR: { id: 464, fieldName: 'therapyVendor' },
});

export const HR = Object.freeze({
  IS_FACILITY_UNION: { id: 465, fieldName: 'isFacilityUnion' },
  CBA_FILE: { id: 466, fieldName: 'CBAFile' },
  ARE_BENEFITS_FROM_UNION: { id: 467, fieldName: 'areBenefitsFromUnion' },
  WAIT_PERIOD: { id: 468, fieldName: 'waitPeriod' },
  BENEFIT_PLANS_FILE: { id: 469, fieldName: 'benefitPlansFile' },
  LAUNDRY_IS_OUTSOURCED: { id: 471, fieldName: 'laundryIsOutsourced' },
  CURRENT_EMPLOYEE_HANDBOOK: { id: 474, fieldName: 'currentEmployeeHandbook' },
  HR_DIRECTOR: { id: 475, fieldName: 'HRDirector' },
  HR_AND_PAYROLL_SAME_PERSON: { id: 476, fieldName: 'HRAndPayrollSamePerson' },
  STAFF_ON_LEAVE: { id: 477, fieldName: 'staffOnLeave' },
  STAFF_ON_ADA: { id: 478, fieldName: 'staffOnADA' },
  IS_STAFF_ON_LEAVE: { id: 479, fieldName: 'isStaffOnLeave' },
  IS_STAFF_ON_ADA: { id: 480, fieldName: 'isStaffOnADA' },
  HOUSEKEEPING_IS_OUTSOURCED: { id: 481, fieldName: 'housekeepingIsOutsourced' },
  HOUSEKEEPING_OUTSOURCED_CATEGORY_ID: { id: 482, fieldName: 'housekeepingOutsourcedCategoryId' },
  HOUSEKEEPING_OUTSOURCED_HOURS_PER_WEEK: { id: 483, fieldName: 'housekeepingOutsourcedHoursPerWeek' },
  HOUSEKEEPING_AVERAGE_MONTHLY_COST: { id: 484, fieldName: 'housekeepingAverageMonthlyCost' },
  HOUSEKEEPING_AND_LAUNDRY_OUTSOURCE_VENDOR: { id: 485, fieldName: 'housekeepingAndLaundryOutsourceVendor' },
  HOUSEKEEPING_OUTSOURCED_COMP_HAS_HR_FILES: { id: 486, fieldName: 'housekeepingOutsourcedCompHasHrFiles' },
  DIETARY_IS_OUTSOURCED: { id: 487, fieldName: 'dietaryIsOutsourced' },
  DIETARY_OUTSOURCED_CATEGORY_ID: { id: 488, fieldName: 'dietaryOutsourcedCategoryId' },
  OUTSOURCED_DIETARY_VENDOR: { id: 489, fieldName: 'outsourcedDietaryVendor' },
  DIETARY_OUTSOURCED_PHONE: { id: 490, fieldName: 'dietaryOutsourcedPhone' },
  DIETARY_OUTSOURCED_EMAIL: { id: 491, fieldName: 'dietaryOutsourcedEmail' },
  DIETARY_OUTSOURCED_HOURS_PER_WEEK: { id: 492, fieldName: 'dietaryOutsourcedHoursPerWeek' },
  DIETARY_OUTSOURCED_COMP_HAS_HR_FILES: { id: 493, fieldName: 'dietaryOutsourcedCompHasHrFiles' },
  THERAPY_OUTSOURCED_CATEGORY_ID: { id: 494, fieldName: 'therapyOutsourcedCategoryId' },
  THERAPY_VENDOR: { id: 495, fieldName: 'therapyVendor' },
  THERAPY_OUTSOURCED_COMP_HAS_HR_FILES: { id: 496, fieldName: 'therapyOutsourcedCompHasHrFiles' },
});

export const ENVIRONMENTAL = Object.freeze({
  HOUSEKEEPING_IS_OUTSOURCED: { id: 497, fieldName: 'housekeepingIsOutsourced' },
  HOUSEKEEPING_OUTSOURCED_CATEGORY_ID: { id: 498, fieldName: 'housekeepingOutsourcedCategoryId' },
  HOUSEKEEPING_OUTSOURCED_HOURS_PER_WEEK: { id: 499, fieldName: 'housekeepingOutsourcedHoursPerWeek' },
  HOUSEKEEPING_AVERAGE_MONTHLY_COST: { id: 500, fieldName: 'housekeepingAverageMonthlyCost' },
  HOUSEKEEPING_AND_LAUNDRY_OUTSOURCE_VENDOR: { id: 501, fieldName: 'housekeepingAndLaundryOutsourceVendor' },
  HOUSEKEEPING_SOAP: { id: 502, fieldName: 'housekeepingSoap' },
  HOUSEKEEPING_SANITIZER: { id: 503, fieldName: 'housekeepingSanitizer' },
  HOUSEKEEPING_LINERS: { id: 504, fieldName: 'housekeepingLiners' },
  HOUSEKEEPING_PAPER_TOWELS: { id: 505, fieldName: 'housekeepingPaperTowels' },
  HOUSEKEEPING_TOILET_PAPER: { id: 506, fieldName: 'housekeepingToiletPaper' },
  HOUSEKEEPING_CHEMICALS: { id: 507, fieldName: 'housekeepingChemicals' },
  HOUSEKEEPING_STAFFING_SCHEDULE: { id: 508, fieldName: 'housekeepingStaffingSchedule' },
  HOUSEKEEPING_MAIN_SUPPLIER: { id: 509, fieldName: 'housekeepingMainSupplier' },
  HOUSEKEEPING_SUPPLIES: { id: 510, fieldName: 'housekeepingSupplies' },
  HOUSEKEEPING_EQUIPMENT_RENTALS: { id: 511, fieldName: 'housekeepingEquipmentRentals' },
  HOUSEKEEPING_EQUIPMENT: { id: 512, fieldName: 'housekeepingEquipment' },
  LAUNDRY_IS_OUTSOURCED: { id: 513, fieldName: 'laundryIsOutsourced' },
  LAUNDRY_STAFFING_SCHEDULE: { id: 514, fieldName: 'laundryStaffingSchedule' },
  LAUNDRY_EQUIPMENT: { id: 515, fieldName: 'laundryEquipment' },
  WASHING_MACHINES: { id: 516, fieldName: 'washingMachines' },
  DRYERS: { id: 517, fieldName: 'dryers' },
  HEAT_PRESSES: { id: 518, fieldName: 'heatPresses' },
  CHEMICALS: { id: 519, fieldName: 'chemicals' },
  LINENS: { id: 520, fieldName: 'linens' },
});

export const TRANSPORTATION = Object.freeze({
  DRIVER_LIST: { id: 521, fieldName: 'driverList' },
  VEHICLE_LIST: { id: 522, fieldName: 'vehicleList' },
  USER_LIST: { id: 523, fieldName: 'userList' },
  TRANSPORTATION_OUTSOURCED_COMPANY: { id: 524, fieldName: 'transportationOutsourcedCompany' },
});

export const BENEFITS = Object.freeze({
  EIN_NUMBER: { id: 525, fieldName: 'EINNumber' },
});

export const PHARMACY = Object.freeze({
  PHARMACY_VENDOR: { id: 526, fieldName: 'pharmacyVendor' },
  PHARMACY_CONSULTANT_VENDOR: { id: 527, fieldName: 'pharmacyConsultantVendor' },
  NUMBER_OF_MED_CARTS: { id: 528, fieldName: 'numberOfMedCarts' },
  MED_CARTS_OWNERSHIP_TYPE_ID: { id: 529, fieldName: 'medCartsOwnershipTypeID' },
  NUMBER_OF_TREATMENT_CARTS: { id: 530, fieldName: 'numberOfTreatmentCarts' },
  TREATMENT_CARTS_OWNERSHIP_TPYE_ID: { id: 531, fieldName: 'treatmentCartsOwnershipTypeID' },
});

export const CLINICAL = Object.freeze({
  PHARMACY_VENDOR: { id: 532, fieldName: 'pharmacyVendor' },
  PHARMACY_CONSULTANT_VENDOR: { id: 533, fieldName: 'pharmacyConsultantVendor' },
  EDUCATION_VENDOR: { id: 534, fieldName: 'educationVendor' },
  MDS_SCRUBBER: { id: 535, fieldName: 'MDSScrubber' },
  CLINICAL_AND_INFECTION_CONTROL_POLICIES: { id: 536, fieldName: 'clinicalAndInfectionControlPolicies' },
  CLIA_WAIVER: { id: 537, fieldName: 'CLIAWaiver' },
  LAB_PERMITS: { id: 538, fieldName: 'LabPermits' },
  NURSING_STAFFING_SCHEDULE: { id: 539, fieldName: 'nursingStaffingSchedule' },
  LAST_3_ANNUAL_SURVEYS: { id: 540, fieldName: 'last3AnnualSurveys' },
  LAST_3_YEARS_COMPLAINTS: { id: 541, fieldName: 'last3YearsComplaints' },
  ADMISSION_PAYMENT_BAN_CORRESPONDENCE: { id: 542, fieldName: 'admissionPaymentBanCorrespondence' },
  QAPI: { id: 543, fieldName: 'QAPI' },
  FACILITY_ASSESSMENT: { id: 544, fieldName: 'facilityAssessment' },
  IS_JCAHO_CERTIFIED: { id: 545, fieldName: 'isJCAHOCertified' },
  WORKS_WITH_PA_QIO: { id: 546, fieldName: 'worksWithPAQIO' },
  EQUIPMENT_OPTIONS: { id: 547, fieldName: 'equipmentOptions' },
  GLUCOMETER_MANUFACTURER: { id: 548, fieldName: 'glucometerManufacturer' },
  GLUCOMETER_TPY: { id: 549, fieldName: 'glucometerTPY' },
  COVID_TEST_MANUFACTURER: { id: 550, fieldName: 'covidTestManufacturer' },
  COVID_TEST_TPY: { id: 551, fieldName: 'covidTestTPY' },
  URINE_TEST_MANUFACTURER: { id: 552, fieldName: 'urineTestManufacturer' },
  URINE_TEST_TPY: { id: 553, fieldName: 'urineTestTPY' },
  FECAL_TEST_MANUFACTURER: { id: 554, fieldName: 'fecalTestManufacturer' },
  FECAL_TEST_TPY: { id: 555, fieldName: 'fecalTestTPY' },
  MD_FIRST_NAME: { id: 556, fieldName: 'mdFirstName' },
  MD_LAST_NAME: { id: 557, fieldName: 'mdLastName' },
  MD_ADDRESS: { id: 558, fieldName: 'mdAddress' },
  MD_CITY: { id: 559, fieldName: 'mdCity' },
  MD_STATE: { id: 560, fieldName: 'mdState' },
  MD_ZIP: { id: 561, fieldName: 'mdZip' },
  MD_PHONE_NUMBER: { id: 562, fieldName: 'mdPhoneNumber' },
  MD_FAX: { id: 563, fieldName: 'mdFax' },
  MD_EMAIL: { id: 564, fieldName: 'mdEmail' },
  MD_COMPANY: { id: 565, fieldName: 'mdCompany' },
  NPI_NUMBER: { id: 566, fieldName: 'npiNumber' },
  DEA_NUMBER: { id: 567, fieldName: 'deaNumber' },
  MEDICAL_DIRECTOR_LICENSE: { id: 568, fieldName: 'medicalDirectorLicense' },
  MEDICAL_DIRECTOR_CONTRACT: { id: 569, fieldName: 'medicalDirectorContract' },
  PODIATRIST: { id: 570, fieldName: 'podiatrist' },
  EYE_CARE: { id: 571, fieldName: 'eyeCare' },
  DENTAL: { id: 572, fieldName: 'dental' },
  AUDIOLOGY: { id: 573, fieldName: 'audiology' },
  ADDITIONAL_MEDICAL_PROFESSIONALS: { id: 574, fieldName: 'additionalMedicalProfessionals' },
  PROGRAMS: { id: 575, fieldName: 'programs' },
  WAIVED_TESTS_PER_YEAR: { id: 576, fieldName: 'waivedTestsPerYear' },
  NOT_WAIVED_TESTS_PER_YEAR: { id: 577, fieldName: 'notWaivedTestsPerYear' },
  CNA_TRAINING: { id: 578, fieldName: 'CNATraining' },
  FLU_VACCINE: { id: 579, fieldName: 'fluVaccine' },
  NHSN_ACCESS: { id: 580, fieldName: 'NHSNUsers' },
  ADMINISTRATOR: { id: 581, fieldName: 'administrator' },
  DIRECTOR_OF_NURSING: { id: 582, fieldName: 'directorOfNursing' },
  ADON: { id: 583, fieldName: 'ADON' },
  INFECTION_CONTROL: { id: 584, fieldName: 'infectionControl' },
});
